import React, { useState, useEffect } from 'react';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { AdjuntosExpatriadosHistoricoScreen } from './screen';
import { PaisesAdapter } from '../../../../../infraestructure/persistence/rest/PaisesAdapter';
import { downloadFile } from '../../../../../shared/utils/download';
import { AdjuntosAdapter } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';
//import { useProfile } from '../../../../../shared/hooks/Profile';

const AdjuntosExpatriadosHistoricoContainer = (props:any) => {

	const {translate} = props;

	const api = new UsuariosAdapter();
	const apiPaises = new PaisesAdapter();
	const apiAdjuntos = new AdjuntosAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	//const {profile} = useProfile();

	let [ data, setData ] = useState<any>([]);
	let result: any;

	useEffect(() => {
		//profile!==undefined && getPaises(profile);
		getPaises();
	}, []);

	const getPaises = async () => {
		try {
			result = await apiPaises.ListarPaisesExpatriadosHistorico();
			if(result.data && result.data!=="")
			{
				setData([...result.data]);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const DownloadAdjuntoHistoricoExpatriado = async (dataRequest:any) => {
		const {user,adjunto} = dataRequest;
		const request = {idEmpleado:user.idEmpleado, idAdjunto:adjunto.idAdjunto, fechaDesde:adjunto.fechaDesde, fechaHasta: adjunto.fechaHasta}
		
		try {
			result = await apiAdjuntos.DescargarAdjuntoHistoricoExpatriado(request);
			if(result.data && result.data!=="")
			{
				const adjuntoParts = adjunto.nombre.split('.');
				const fileName = `${adjuntoParts[0]}_${user.empleado}_${adjunto.fechaDesde}_${adjunto.fechaHasta}.${adjuntoParts[1]}`
				await downloadFile(result.data,fileName)
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const DownloadAllAdjuntosHistoricoExpatriado = async (dataRequest:any) => {
		const {user} = dataRequest;
		const request = {idEmpleado:user.idEmpleado, fechaDesde:user.fechaDesde,fechaHasta:user.fechaHasta}

		try {
			result = await apiAdjuntos.DescargarTodosAdjuntosHistoricoExpatriado(request);
			if(result.data && result.data!=="")
			{
				let filenameContent = result.headers['content-disposition'].split(';')[1];
				let filename = filenameContent.substring(10,filenameContent.length-1);
				await downloadFile(result.data,filename)
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};


	const GetAdjuntosHistoricoPorPais= async (pais:any,fnCallBack:any) => {
		const request = {codPais:pais.codPais}
		try {
			result = await api.GetAdjuntosHistoricoPorPais(request);
			if(result.data && result.data!=="")
			{
				//setData([...result.data]);
				fnCallBack({...pais,...{historico:result.data}});
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	
    return (
        <AdjuntosExpatriadosHistoricoScreen data={data} 
		handleGetAdjuntosHistoricoPorPais={GetAdjuntosHistoricoPorPais}
		handleDownloadAdjuntoHistorico={DownloadAdjuntoHistoricoExpatriado}
		handleDownloadAllAdjuntosHistorico={DownloadAllAdjuntosHistoricoExpatriado}
		translate={translate}
		/>
    )
};

export default AdjuntosExpatriadosHistoricoContainer;
